import { render, staticRenderFns } from "./IndexDetails.vue?vue&type=template&id=84b84a1c&"
import script from "./IndexDetails.vue?vue&type=script&lang=js&"
export * from "./IndexDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports